import React, { FC, memo } from "react";
import { IRoom, setClass } from "@utils";
import { CollapsibleList } from "../../collapsibleList";
import { FilterRoomOption } from "./FilterRoomOption";
import { isMobile } from "react-device-detect";
import { LoadableWrapper } from "@components";

interface IRoomsProps {
  rooms: IRoom[];
  selectRoomNumber: number;
  onChooseRoom: (roomNumber: number) => void;
  onChooseAllRooms?: () => void;
  allRoomsSelected?: boolean;
  isLoading: boolean;
}

export const Rooms: FC<IRoomsProps> = memo(
  ({
    rooms,
    selectRoomNumber: selected,
    onChooseRoom,
    onChooseAllRooms,
    allRoomsSelected,
    isLoading,
  }) => {
    return (
      <LoadableWrapper loading={isLoading}>
        <div className="block">
          <CollapsibleList<IRoom>
            title="КФЗ"
            listItems={rooms}
            placeholder={"КФЗ нет"}
            maxHeight={400}
            button={
              !isMobile ? (
                <div
                  onClick={onChooseAllRooms}
                  className={setClass(
                    "all-rooms-button",
                    allRoomsSelected && "selected"
                  )}
                >
                  Все КФЗ
                </div>
              ) : null
            }
            renderOption={(room: IRoom) => (
              <FilterRoomOption
                key={room.cabinetNumber}
                room={room}
                selected={selected}
                onChooseRoom={onChooseRoom}
              />
            )}
          />
        </div>
      </LoadableWrapper>
    );
  }
);
